export function createReducer(handlers, initState) {
  return function reducer(state = initState, action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
}
export function removeItem() { }
export function updateItemInObject(object, itemId, props) {
  let oldItem = object[itemId] || {};
  return Object.assign({}, object, {
    [itemId]: Object.assign({}, oldItem, props),
  });
}
export function updateItemInArray() { }
// function updateItemInArray(array, itemId, updateItemCallback) {
//   const updatedItems = array.map((item) => {
//     if (item.id !== itemId) {
//       return item;
//     }

//     // 使用提供的回调来创建新的项目
//     const updatedItem = updateItemCallback(item);
//     return updatedItem;
//   });

//   return updatedItems;
// }
